class AnnouncementBar extends HTMLElement {
  constructor() {
    super();
    this.$announcements = this.querySelectorAll('.announcement-bar__item');
    this.speed = this.hasAttribute('data-speed') ? this.getAttribute('data-speed') : 3000;
    this.activeClass = 'js-announcment-bar-item-active';
    this.interval;

    this.addEventListener('mouseenter', this.pause.bind(this));
    this.addEventListener('mouseleave', this.start.bind(this));

    document.addEventListener('touchstart', this.init.bind(this), {once: true});
    addEventListener('mousemove', this.init.bind(this), {once: true});
  }

  init() {
    this.start();
  }

  pause() {
    clearInterval(this.interval);
  }

  start() {
    const self = this;
    this.interval = setInterval(function(){
      const $current = self.querySelector(`.${self.activeClass}`);
      const $next = $current.nextSibling ? $current.nextSibling : self.$announcements[0]; 

      $current.classList.remove(self.activeClass);
      $next.classList.add(self.activeClass);
    }, this.speed);
  }
}

customElements.define('announcement-bar', AnnouncementBar);